<script>
    import List, { Item, Text, PrimaryText, SecondaryText } from "@smui/list";
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import loading from "../../components/loading";
    import snackbar from "../../components/snackbar";
    import title from "../../components/title";
    import { post } from "../../http";
    import { setObject } from "../../session";

    export let location;

    let origins = [];

    function next(origin) {
        const order = {
            origin_code: origin.origin_code,
            shipper_name: origin.customer_name,
            shipper_phone: origin.customer_phone,
            shipper_address: origin.address,
            shipper_province: origin.province,
            shipper_city: origin.city,
            shipper_district: origin.district,
            shipper_zipcode: "-",
        };
        setObject("order", order);
        navigate("/destination");
    }

    onMount(() => {
        title.set("Pilih alamat pengiriman");
        loading.show();
        post("/api/address_list")
            .then((resp) => {
                if (resp.status == 0) origins = resp.data;
                else snackbar.open(resp.message);
            })
            .finally(() => loading.hide());
    });
</script>

<div class="content">
    <List class="address" threeLine>
        {#each origins as origin}
            <Item on:SMUI:action={() => next(origin)}>
                <Text>
                    <PrimaryText>{origin.address_name}</PrimaryText>
                    <SecondaryText>{origin.customer_name}</SecondaryText>
                    <SecondaryText>{origin.address}</SecondaryText>
                </Text>
            </Item>
        {/each}
    </List>
</div>
